var BaseClaims = /** @class */ (function () {
    function BaseClaims() {
    }
    // Users
    BaseClaims.Dashboard = "Dashboard";
    BaseClaims.CanAccessUsers = "CanAccessUsers";
    BaseClaims.CanAddUsers = "CanAddUsers";
    BaseClaims.CanDeleteUsers = "CanDeleteUsers";
    BaseClaims.CanUpdateUsers = "CanUpdateUsers";
    // Permissions
    BaseClaims.CanAccessPermissions = "CanAccessPermissions";
    BaseClaims.CanUpdatePermissions = "CanUpdatePermissions";
    // Lookups
    BaseClaims.ManageBranches = "ManageBranches";
    BaseClaims.ManageUsers = "ManageUsers";
    BaseClaims.ManageLookups = "ManageLookups";
    BaseClaims.CanAccessLookups = "CanAccessLookups";
    BaseClaims.CanAddLookups = "CanAddLookups";
    BaseClaims.CanDeleteLookups = "CanDeleteLookups";
    BaseClaims.CanUpdateLookups = "CanUpdateLookups";
    BaseClaims.CanTakeOwnership = "CanTakeOwnership";
    BaseClaims.ViewAuditHistory = "ViewAuditHistory";
    BaseClaims.ViewAuditOwnActions = "ViewAuditOwnActions";
    BaseClaims.ViewAuditOwnDepartment = "ViewAuditOwnDepartment";
    BaseClaims.ViewAuditOtherDepartments = "ViewAuditOtherDepartments";
    return BaseClaims;
}());
export { BaseClaims };
